interface OfflineSyncProgressBarProps {
  progress: number;
}

export default function OfflineSyncProgressBar({ progress }: OfflineSyncProgressBarProps) {
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-1/3 sm:right-1/3 z-50 bg-white dark:bg-gray-800 border shadow-lg rounded-md px-4 py-2">
      <p className="text-sm mb-1">Syncing data...</p>
      <div className="w-full bg-gray-200 dark:bg-gray-700 h-2 rounded-full overflow-hidden">
        <div
          className="bg-blue-600 h-2 transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
